import { Theme } from '@mui/material';

export default function MenuItem(theme: Theme) {
  return {
    MuiMenuItem: {},
  };
}
